export const SHOW_POPUP = 'SHOW_POPUP'
export const CLOSE_POPUP = 'CLOSE_POPUP'
export const SHOW_TERMS = 'SHOW_TERMS'
export const CLOSE_TERMS = 'CLOSE_TERMS'
